import React from 'react';
const ButtonElement = () => <div className="builder-button" style={{padding:'1rem',border:'1px dashed #ccc'}}>🔘 Button (Coming Soon)</div>;
export default ButtonElement;
